import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const preqExpenseCategory = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/prerequisite/expense-categories',
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,
    },
};
